import Icon from '../design/Icon';
import type { MemberGym } from '../hooks/useMemberGyms';
import { deskReason, frontDeskNumber } from '../bookingPay';

/* A paid drop-in the gym will not let a member book unpaid, at a gym that does
   not collect online: the desk takes it. Says why and offers the number,
   rather than a book button that would only be refused (PAYMENT_REQUIRED). */

export default function FrontDeskNote({ gym }: { gym: MemberGym | null }) {
  const phone = frontDeskNumber(gym);
  return (
    <div className="card flat" style={{ padding: '12px 14px' }}>
      <div className="col" style={{ gap: 8 }}>
        <div className="row" style={{ gap: 8, alignItems: 'flex-start' }}>
          <Icon n="help" s={15} c="var(--ink-3)" />
          <span className="sub wrap">{deskReason(gym)} Ask the front desk to book this for you.</span>
        </div>
        {phone && (
          <div className="row" style={{ gap: 8 }}>
            <a className="btn ghost sm" href={`tel:${phone}`}>Call {phone}</a>
          </div>
        )}
      </div>
    </div>
  );
}
